import { onBeforeUnmount } from "vue";

export function useDebounce(fn, delay = 300) {
  let timer = null;

  const debounced = (...args) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };

  onBeforeUnmount(() => {
    clearTimeout(timer);
  });

  return debounced;
}
